/* Opportunity Detail View */
import * as React from "react";
import { inject, observer } from "mobx-react";
import { action, observable } from "mobx";
import { Opportunity, Prereq, SkillSet, SetSkill } from "../../models/opportunity";
import SeekerStore from "../../stores/seekerStore";
import { CourseOffering } from "../../models/education";
import { OpportunityViewState, ScreenMode, PositionLevel, AddExpRoute, BusyEvent } from "../../models/enums";
import { ILocalization } from "../../models/localization";
import { hashHistory } from "react-router";
import Busy from "../../components/widgets/busy";
import OpportunityStore from "../../stores/opportunityStore";
import { Row, Col, Grid } from "react-flexbox-grid";
import BackButton from "../../components/widgets/backBtn";
import { SaveAction, ApplyAction, DownloadPdfAction, NoApplyAction, ConfirmationDlg} from "../../components/opportunity/actions";
import { OpSkills } from "../../components/opportunity/skills";
import { Education } from "../../components/opportunity/educationSlider";
import { Description } from "../../components/opportunity/description";
import { TabsHorizontal } from "../../components/opportunity/tabsHorizontal";
import { TabsVertical } from "../../components/opportunity/tabsVertical"; 
import { HeaderDesktop, HeaderTablet, HeaderMobile } from "../../components/opportunity/headerImg";
import WorkExperienceEditor from "../../components/profile/workExperienceEditor";
import MilitaryExperienceEditor from "../../components/profile/militaryExperienceEditor";
import ActivityExperienceEditor from "../../components/profile/lifeExperienceEditor";
import EducationExperienceEditor from "../../components/profile/educationExperienceEditor";
import CCLCEditor from "../../components/profile/cclcEditor";
import LangEditor from "../../components/profile/langEditor";
import AddEditNavBtns from "../../components/profile/addEditNavBtns";
import AddExperienceVw from "../addExperience";
import SkillPicker from "../../components/profile/skillSuggestions";
import RelatedOps from "../../components/opportunity/relatedOps";
import VideoOps from "../../components/opportunity/videoOps";
import Paper from "material-ui/Paper";
import * as s from "./opportunity.css";

interface IParams {
  opId: string;
}

@inject("store") @observer
export default class OpportunityVw extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _opStore: OpportunityStore;
  @observable viewState: number;
  private skillViewRef: HTMLDivElement;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
    this.skillViewRef = null;
  }
  componentWillMount(): void {
    if (!this.props.store.viewState.requireAuthentication()) {
        return;
    }   
    this.props.store.viewState.trackView();
    this._opStore.selectOpportunity(this.props.params.opId, true);
    this._opStore.getRelatedOpportunities(this.props.params.opId);  
    this.props.store.educationStore.getCoursesForOpportunity(this.props.params.opId);
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    this.props.store.getHelpTopics();
    if (this.props.store.profileStore.addExpRoute === AddExpRoute.Apply) {
      this.scrollToBottom();
    }
  }

  componentWillUpdate(): void {
    this._opStore.selectOpportunity(this.props.params.opId, true);
    window.scrollTo(0, 0);
  }

  componentDidUpdate() {
    if (this.props.store.profileStore.addExpRoute === AddExpRoute.Apply) {
      this.scrollToBottom();
    }
  }

  componentWillUnmount(): void {
    this._opStore.clearOpportunity();
    this.props.store.educationStore.clear();
    this.props.store.profileStore.setAddExpRoute(AddExpRoute.All);
    this.props.store.opportunityStore.setViewState(0);
  }

  scrollToBottom = ():void => {
    this.skillViewRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });    
  }

  @action closeDialog = (): void => {
    this.props.store.viewState.closeOpportunity();
  }

  renderHeaderDesktop(): JSX.Element {
    return (<Row className={s.container}><HeaderDesktop store={this.props.store} params={this.props.params} />
      {this.props.store.educationStore.courses.length > 0 && <Col xs={0} md={4} className={s.slider}><Education store={this.props.store} params={this.props.params} /></Col>}
    </Row>)
  }

  renderHeaderTablet(): JSX.Element {
    return (
      <HeaderTablet store={this.props.store} params={this.props.params} />)
  }

  renderHeaderMobile(): JSX.Element {
    return (<HeaderMobile store={this.props.store} params={this.props.params} />)
  }

  renderTabsVertical(): JSX.Element {
    return (<Row><TabsVertical store={this.props.store} params={this.props.params} /></Row>)
  }

  renderTabsHorizontal(): JSX.Element {
      return (<Row><TabsHorizontal store={this.props.store} params={this.props.params} /></Row>)
  }

  renderVideo(): JSX.Element {
    return (<VideoOps store={this.props.store} params={this.props.params} />)
  }

  renderDescription(): JSX.Element {
    return (<Row><Col xs={12}><Description store={this.props.store} params={this.props.params} /></Col></Row>)
  }

  renderEducation(): JSX.Element {
    if (this.props.store.educationStore.courses.length === 0) {
          return null;
    }
    return (<Row around="xs" className={s.educationRow}><Col xs={12}> <Education store={this.props.store} params={this.props.params} /></Col></Row>)
  }

  renderSkillSection(): JSX.Element {
    return (<Row around="lg"><div style={{ float: "left", clear: "both" }} ref={(el) => { this.skillViewRef = el; }}></div>
          <OpSkills store={this.props.store} params={this.props.params} />
              </Row>)
  }

  renderActionButtons(op: Opportunity): JSX.Element {
    return (<Row around="lg" className={s.actionBtnRow}>
            <Col xs={12} sm={4} md={4} className={s.actionCol}><SaveAction store={this.props.store} /></Col>
            <Col xs={12} sm={4} md={4}  className={s.actionCol}>
              {op.allowApply && <ApplyAction store={this.props.store} />}
              {!op.allowApply && <NoApplyAction store={this.props.store} />}
            </Col>
            <Col xs={12} sm={4} md={4}  className={s.actionCol}><DownloadPdfAction store={this.props.store} /></Col >
            </Row>)
  }

  render(): JSX.Element {
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    if (!this._opStore.selectedOp || !this.props.store.profileStore.profile) {
      return <div>Loading...</div>;
    } else {
       return (<div>
         <Grid className={s.opGrid}>
          {mode === ScreenMode.Desktop && this.renderHeaderDesktop()}
          {mode === ScreenMode.Tablet && this.renderHeaderTablet()}
          {mode === ScreenMode.Mobile && this.renderHeaderMobile()}
          {mode === ScreenMode.Desktop && this.renderTabsHorizontal()}
          {mode !== ScreenMode.Desktop && this.renderTabsVertical()}
          {this.renderVideo()}
          {this.renderActionButtons(this._opStore.selectedOp)}
          {mode !== ScreenMode.Desktop && this.renderDescription()}
          {this.renderSkillSection()}          
          {mode !== ScreenMode.Desktop && this.renderEducation()}
          <RelatedOps store={this.props.store} />
         </Grid>
         <ConfirmationDlg store={this.props.store} />
        </div>)
   }
  }
}


// WEBPACK FOOTER //
// ./src/views/opportunity/index.tsx